import CybersecurityAwarenessMonthApplyPage from '@/components/CybersecurityAwarenessMonthApplyPage';
import type { Route } from './+types/home';

export function meta({}: Route.MetaArgs) {
  return [
    { title: 'Apply | $1,000 Secure Coding Credit | Simulations Labs' },
    {
      name: 'description',
      content:
        'Apply for $1,000 in Simulations Labs platform credit this Cybersecurity Awareness Month and train your developers on real vulnerabilities.',
    },
  ];
}

export default function CybersecurityAwarenessMonthApply() {
  return <CybersecurityAwarenessMonthApplyPage />;
}
